
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"20","height":"20","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.167 17.084H5.834c-2.5 0-4.167-1.25-4.167-4.167V7.084c0-2.917 1.667-4.167 4.167-4.167h8.333c2.5 0 4.167 1.25 4.167 4.167v5.833c0 2.917-1.667 4.167-4.167 4.167z","fill":"none","stroke":"#e0e4ec","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"data-name":"Vector","d":"M14.166 7.5l-2.608 2.083a2.638 2.638 0 01-3.125 0L5.833 7.5","fill":"none","stroke":"#e0e4ec","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5","opacity":".4"}})])
          )
        }
      }
    